import { useParams } from '@tanstack/react-router';

import { MemberDetailPage } from './MemberDetailPage';

export const AdminMemberDetailPage = () => {
    const { id } = useParams({ from: '/_app/members/$id' });
    return <MemberDetailPage userId={id} />;
};
